import React, { ReactNode } from 'react';
import { Box, Flex, Icon } from '@qga/roo-ui/components';

import Heading from '../../../../../../components/Heading';
import LinkButton from '../../../../../../components/LinkButton';
import ModalContext from '../../ModalContext';

interface HeaderProps {
  children: ReactNode;
  showCloseButton?: boolean;
  hideBorderBottom?: boolean;
}

const Header = ({
  children,
  showCloseButton = true,
  hideBorderBottom,
}: HeaderProps) => (
  <ModalContext.Consumer>
    {({ onClose }) => (
      <Box
        p="4"
        borderBottom={hideBorderBottom ? '0' : '1'}
        bg="background.card"
        borderColor="border"
        position="relative"
      >
        <Box mb="0" pr="7">
          <Heading.h4
            as="h1"
            fontSize={['md', null, 'lg']}
            data-testid="MODAL_HEADER"
          >
            {children}
          </Heading.h4>
        </Box>
        {showCloseButton && (
          <Flex
            position="absolute"
            right="0"
            top="0"
            bottom="0"
            pr={['1', null, '3']}
          >
            <LinkButton
              data-testid="CLOSE_BUTTON"
              onClick={() => onClose()}
              p="2"
            >
              <Icon color="icon.inclusion" name="close" />
            </LinkButton>
          </Flex>
        )}
      </Box>
    )}
  </ModalContext.Consumer>
);

export default Header;
